// "Escalate to on-call support" dialog (Help menu): pages fastn's on-call engineer (KAT-8489).
export const urgentEscalationTestIds = {
  modal: 'urgent-escalation-modal',
  closeButton: 'urgent-escalation-close-button',
  form: 'urgent-escalation-form',
  summaryInput: 'urgent-escalation-summary-input',
  impactDropdown: 'urgent-escalation-impact-dropdown',
  detailsTextarea: 'urgent-escalation-details-textarea',
  startedDropdown: 'urgent-escalation-started-dropdown',
  affectedInput: 'urgent-escalation-affected-input',
  phoneInput: 'urgent-escalation-phone-input',
  nextStepsText: 'urgent-escalation-next-steps-text',
  confirmCheckbox: 'urgent-escalation-confirm-checkbox',
  errorMessage: 'urgent-escalation-error-message',
  missingHint: 'urgent-escalation-missing-hint',
  cancelButton: 'urgent-escalation-cancel-button',
  submitButton: 'urgent-escalation-submit-button',
  successPanel: 'urgent-escalation-success-panel',
  incidentRef: 'urgent-escalation-incident-text',
  followUpText: 'urgent-escalation-follow-up-text',
  availabilityText: 'urgent-escalation-availability-text',
  openConversationButton: 'urgent-escalation-open-conversation-button',
  doneButton: 'urgent-escalation-done-button',
} as const;
